import { IEventEventType } from "./eventEventType";

export interface ISaveEventEventType {
    id: string;
    eventTypeId: string;
    eventTypeCategory: number;
    modifyDate: number;
}

export class SaveEventEventType implements ISaveEventEventType {
    id: string;
    eventTypeId: string;
    eventTypeCategory: number;
    modifyDate: number;

    constructor();
    constructor(obj: IEventEventType);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.eventTypeId = obj && obj.eventTypeId || "";
        this.eventTypeCategory = obj && obj.eventTypeCategory || 0;
        this.modifyDate = obj && obj.modifyDate || 0;
    }
}